import { createReducer, on } from '@ngrx/store';

import { DynamicTicketType } from '@app/services/dynamic-ticket-type.service';
import { RestProjectTypeModel } from '@main-application/management/pages/service-configuration/project-types/project-types.interface';

import {
  clearDynamicTickets,
  clearProjectTypes,
  createDynamicTicketSuccess,
  createProjectTypeSuccess,
  deleteDynamicTicketSuccess,
  deleteProjectTypeSuccess,
  dynamicTicketsLoadedSuccess,
  dynamicTicketsLoading,
  editDynamicTicketSuccess,
  editProjectTypesSuccess,
  getServiceConfig,
  getServiceConfigError,
  getServiceConfigSuccess,
  loadDynamicTickets,
  loadDynamicTicketsFailed,
  loadDynamicTicketsSuccess,
  loadProjectTypes,
  loadProjectTypesFailed,
  loadProjectTypesSuccess,
  openDynamicTicketCreationModal,
  openProjectTypeCreationModal,
  setServiceSectionExpanded,
} from './service-configuration.actions';

export const serviceConfigurationFeatureKey = 'serviceConfiguration';

export interface State {
  expandedSections: {
    Statuses: boolean;
    Resident: boolean;
    Triggers: boolean;
    ticketTypes: boolean;
    projectTypes: boolean;
  };
  dynamicTicketLoading?: boolean;
  dynamicTickets: DynamicTicketType[];
  openDynamicTicketCreationModal: number;
  projectTypesLoading?: boolean;
  projectTypes: RestProjectTypeModel[];
  openProjectTypeCreationModal: number;
}

export const initialState: State = {
  expandedSections: {
    Statuses: true,
    Resident: false,
    Triggers: false,
    ticketTypes: false,
    projectTypes: false,
  },
  dynamicTicketLoading: false,
  dynamicTickets: null,
  openDynamicTicketCreationModal: null,
  openProjectTypeCreationModal: null,
  projectTypesLoading: false,
  projectTypes: null,
};

export const reducer = createReducer(
  initialState,
  on(getServiceConfig, (state, action) => ({ ...state, serviceConfigLoading: false })),
  on(getServiceConfigSuccess, (state, action) => ({
    ...state,
    serviceConfigLoading: false,
    serviceConfig: action.serviceConfig,
  })),
  on(getServiceConfigError, (state, action) => ({
    ...state,
    serviceConfigLoading: false,
    serviceConfig: null,
  })),
  on(setServiceSectionExpanded, (state, action) => {
    const collapsed: State['expandedSections'] = {
      Statuses: false,
      Resident: false,
      Triggers: false,
      ticketTypes: false,
      projectTypes: false,
    };
    return {
      ...state,
      expandedSections: action.state
        ? { ...collapsed, [action.section]: true }
        : { ...state.expandedSections, [action.section]: false },
    };
  }),
  on(dynamicTicketsLoading, state => ({
    ...state,
    dynamicTicketLoading: true,
  })),
  on(dynamicTicketsLoadedSuccess, state => ({
    ...state,
    dynamicTicketLoading: false,
  })),
  on(openDynamicTicketCreationModal, (state, action) => ({
    ...state,
    openDynamicTicketCreationModal: action.create,
  })),

  on(loadDynamicTickets, state => ({ ...state, dynamicTicketLoading: true })),
  on(loadDynamicTicketsSuccess, (state, action) => ({
    ...state,
    dynamicTicketLoading: false,
    dynamicTickets: action.items,
  })),
  on(loadDynamicTicketsFailed, (state, action) => ({
    ...state,
    dynamicTicketLoading: false,
    dynamicTickets: [],
  })),
  on(createDynamicTicketSuccess, (state, newItem) => ({
    ...state,
    dynamicTickets: [...state.dynamicTickets, newItem],
  })),
  on(editDynamicTicketSuccess, (state, updatedItem) => ({
    ...state,
    createDiligenceLoading: false,
    dynamicTickets: state.dynamicTickets.map(item => (item.id === updatedItem.id ? updatedItem : item)),
  })),
  on(deleteDynamicTicketSuccess, (state, action) => ({
    ...state,
    dynamicTickets: [...state.dynamicTickets?.filter(el => el.id !== action.id)],
  })),
  on(clearDynamicTickets, state => ({ ...state, dynamicTickets: null })),

  on(loadProjectTypes, state => ({ ...state, projectTypesLoading: true })),
  on(loadProjectTypesSuccess, (state, action) => ({
    ...state,
    projectTypesLoading: false,
    projectTypes: action.items,
  })),
  on(loadProjectTypesFailed, (state, action) => ({
    ...state,
    projectTypesLoading: false,
    projectTypes: [],
  })),
  on(openProjectTypeCreationModal, (state, action) => ({
    ...state,
    openProjectTypeCreationModal: action.create,
  })),
  on(createProjectTypeSuccess, (state, newItem) => ({
    ...state,
    projectTypes: [...state.projectTypes, newItem],
  })),
  on(editProjectTypesSuccess, (state, updatedItem) => ({
    ...state,
    projectTypes: state.projectTypes.map(item => (item.id === updatedItem.id ? updatedItem : item)),
  })),
  on(deleteProjectTypeSuccess, (state, action) => ({
    ...state,
    projectTypes: [...state.projectTypes?.filter(el => el.id !== action.id)],
  })),
  on(clearProjectTypes, state => ({ ...state, projectTypes: null }))
);
